import { RecipientChangeWarningDialogComponent } from '../recipient-change-warning-dialog/recipient-change-warning-dialog.component';
import { SendEmailService } from '../send-email.service';
import { Recipient } from '../recipient.model';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { MailDetail } from '../mail-detail';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { LoginService } from '../../login/login.service';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { UserService } from '../../../shared-components/user/user.service';

/**
 * DO
 * NOT
 * CHANGE
 * THE
 * REFERENCES
 * FOR
 * TOSELECTIONS
 * CCSELECTIONS
 * BCCSELECTIONS
 */
@Component({
    selector: 'change-recipients',
    templateUrl: './change-recipients-dialog.component.html',
    styleUrls: [
        './change-recipients-dialog.component.css'
    ]
})
export class ChangeRecipientsDialogComponent implements OnInit, OnDestroy {

    // Injected Properties
    private _viewOption = 3;
    mailDetail: MailDetail;
    teacherEmailAddress: string;
    userEmailAddress: string;

    // Local Properties
    private _allAdvisors = false;
    private _allPrincipals = false;
    private _allCounselors = false;
    private _allSiteAdministrators = false;
    private _allDistrictAdministrators = false;
    private _allCoTeachers = true;
    private _allNurses = false;
    errors: ErrorList[] = [];
    V10: boolean;
    toSelections: number[] = [];    // DO NOT CHANGE THIS REFERENCE
    originalToSelections: number[] = [];
    CCSelections: number[] = [];    // DO NOT CHANGE THIS REFERENCE
    originalCCSelections: number[] = [];
    BCCSelections: number[] = [];   // DO NOT CHANGE THIS REFERENCE
    originalBCCSelections: number[] = [];
    _recipients: Recipient[] = [];
    subscriptions: Subscription[] = [];
    tableData: TylerMatTableDataSource;
    columns = ['to', 'CC', 'BCC', 'name', 'relationship'];
    userType: number;
    disableCCTo = false;
    CCDisabledEmailId: number;
    getRecipientSubscription: Subscription;
    obtainingRecipients = false;
    toSelected = false;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<ChangeRecipientsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private loginService: LoginService,
        private sendEmailService: SendEmailService,
        private userService: UserService,
        private dialog: MatDialog
    ) { }

    get allAdvisors(): boolean {
        return this._allAdvisors;
    }

    set allAdvisors(value: boolean) {
        this._allAdvisors = value;
        this.getRecipients();
    }

    get allPrincipals(): boolean {
        return this._allPrincipals;
    }

    set allPrincipals(value: boolean) {
        this._allPrincipals = value;
        this.getRecipients();
    }

    get allCounselors(): boolean {
        return this._allCounselors;
    }

    set allCounselors(value: boolean) {
        this._allCounselors = value;
        this.getRecipients();
    }

    get allSiteAdministrators(): boolean {
        return this._allSiteAdministrators;
    }

    set allSiteAdministrators(value: boolean) {
        this._allSiteAdministrators = value;
        this.getRecipients();
    }

    get allDistrictAdministrators(): boolean {
        return this._allDistrictAdministrators;
    }

    set allDistrictAdministrators(value: boolean) {
        this._allDistrictAdministrators = value;
        this.getRecipients();
    }

    get viewOption(): number {
        return this._viewOption;
    }

    set viewOption(value: number) {
        this._viewOption = value;
        this.getRecipients(true);
    }

    get allCoTeachers(): boolean {
        return this._allCoTeachers;
    }

    set allCoTeachers(value: boolean) {
        this._allCoTeachers = value;
        this.getRecipients();
    }

    get allNurses(): boolean {
        return this._allNurses;
    }

    set allNurses(value: boolean) {
        this._allNurses = value;
        this.getRecipients();
    }


    recipients: Recipient[];


    // Event Functions
    ngOnInit() {
        // PRE: injected dialog data with the injected properties
        // POST: initializes the data

        // Checking injected data members
        this._viewOption = this.data.viewOption;
        this.mailDetail = this.data.mailDetail;
        this.teacherEmailAddress = this.data.teacherEmailAddress;
        this.userEmailAddress = this.data.userEmailAddress;
        if (this.data.toSelections) {
            this.toSelections = this.data.toSelections;
            this.originalToSelections = Object.assign([], this.data.toSelections);
        }
        if (this.data.CCSelections) {
            this.CCSelections = this.data.CCSelections;
            this.originalCCSelections = Object.assign([], this.data.CCSelections);
        }
        if (this.data.BCCSelections) {
            this.BCCSelections = this.data.BCCSelections;
            this.originalBCCSelections = Object.assign([], this.data.BCCSelections);
        }

        // Initializing local data members
        this._allAdvisors = this.sendEmailService.allAdvisors;
        this._allCounselors = this.sendEmailService.allCounselors;
        this._allPrincipals = this.sendEmailService.allPrincipals;
        this._allSiteAdministrators = this.sendEmailService.allSiteAdmin;
        this._allDistrictAdministrators = this.sendEmailService.allDistrictAdmin;
        this.V10 = this.loginService.LoginSettings.V10;
        this.userType = this.userService.currentUser.UserType;
        this.subscriptions.push(
            this.sendEmailService.observableRecipientsStream$.subscribe(recipients => {
                this.recipients = recipients;
                if (this.V10 == false && this.recipients.length != 0) {
                    const currentUserRecipientId = this.recipients.find(x => x.Email == this.userService.currentUser.Email).Id;
                    if (currentUserRecipientId == null || this.CCSelections.indexOf(currentUserRecipientId) < 0) {
                        this.CCSelections.splice(0, this.CCSelections.length);
                        this.CCSelections.push(this.recipients.find(x => x.Email == this.userService.currentUser.Email).Id);
                    }
                }
                this.tableData = new TylerMatTableDataSource(this.recipients);
            })
        );
        if (this.recipients.length == 0) {
            this.getRecipients();
        }
    }

    ngOnDestroy() {
        // POST: unsubscribes to all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    ok() {
        // PRE: the ok button is clicked
        // POST: closes the dialogBox

        // Checking for errors
        if (this.toSelections.length == 0 && this.userType != 1) {
            this.errors = [];
            this.errors.push({
                fieldName: null,
                fieldRef: null,
                errorMsg: 'At least one <b>To</b> recipient must be selected.'
            });
        }

        // Continuing with save
        else {

            // Adjusting the mail details
            this.mailDetail.peopleIds = '';
            this.mailDetail.personCodeMother = 0;
            this.mailDetail.personCodeFather = 0;
            this.mailDetail.toSelectedMailId = '';
            this.mailDetail.CCSelectedMailId = '';
            this.mailDetail.CCDisplayMailId = '';
            this.mailDetail.BCCSelectedMailId = '';
            this.mailDetail.BCCDisplayMailId = '';
            this.toSelected = undefined;

            // Adjusting the To selections
            this.recipients.forEach(recipient => {
                if (recipient.Id != null && this.toSelections.length > 0) {
                    this.toSelected = true;
                    if (this.toSelections.indexOf(recipient.Id) > -1) {
                        let addedRecipient = recipient.Name;
                        if (recipient.UserType == 1 || this.userService.currentUser.UserType == 1) {
                            addedRecipient += ' <' + recipient.Email + '>';
                        }
                        if (this.mailDetail.toSelectedMailId.length == 0) {
                            this.mailDetail.toSelectedMailId = addedRecipient;
                            this.mailDetail.toMailId = recipient.Email;
                        }
                        else {
                            this.mailDetail.toSelectedMailId = this.mailDetail.toSelectedMailId + '; ' + addedRecipient;
                            this.mailDetail.toMailId = this.mailDetail.toMailId + ';' + recipient.Email;
                        }

                        if (this.mailDetail.peopleIds == '') {
                            this.mailDetail.peopleIds = recipient.Id + '||' + recipient.Relationship;
                        } else {
                            this.mailDetail.peopleIds = this.mailDetail.peopleIds + ',' + recipient.Id + '|| ';
                        }

                        if (recipient.Relationship == 'Mother' || recipient.Relationship == 'Step Mother') {
                            this.mailDetail.personCodeMother = 1;
                        }
                        if (recipient.Relationship == 'Father' || recipient.Relationship == 'Step Father') {
                            this.mailDetail.personCodeFather = 2;
                        }
                    }
                }
            });

            // Adjusting the CC selections
            this.recipients.forEach(recipient => {
                if (recipient.Id != null && this.CCSelections.length > 0) {
                    if (this.CCSelections.indexOf(recipient.Id) > -1) {
                        let addedRecipient = recipient.Name;
                        if (recipient.UserType == 1 || this.userService.currentUser.UserType == 1) {
                            addedRecipient += ' <' + recipient.Email + '>';
                        }
                        if (this.mailDetail.CCDisplayMailId.length == 0) {
                            this.mailDetail.CCDisplayMailId = addedRecipient;
                        } else {
                            this.mailDetail.CCDisplayMailId = this.mailDetail.CCDisplayMailId + '; ' + addedRecipient;
                        }
                        if (this.mailDetail.CCSelectedMailId.length == 0) {
                            this.mailDetail.CCSelectedMailId = addedRecipient;
                            this.mailDetail.CCMailId = recipient.Email;
                        }
                        else {
                            this.mailDetail.CCSelectedMailId = this.mailDetail.CCSelectedMailId + addedRecipient + ' ';
                            this.mailDetail.CCMailId = this.mailDetail.CCMailId + ';' + recipient.Email;
                        }

                        if (this.mailDetail.peopleIds == '') {
                            this.mailDetail.peopleIds = recipient.Id + '||' + recipient.Relationship;
                        } else {
                            this.mailDetail.peopleIds = this.mailDetail.peopleIds + ',' + recipient.Id + '|| ';
                        }

                        if (recipient.Relationship == 'Mother' || recipient.Relationship == 'Step Mother') {
                            this.mailDetail.personCodeMother = 1;
                        }
                        if (recipient.Relationship == 'Father' || recipient.Relationship == 'Step Father') {
                            this.mailDetail.personCodeFather = 2;
                        }
                    }
                }
            });

            // Adjusting the BCC selections
            this.recipients.forEach(recipient => {
                if (recipient.Id != null && this.BCCSelections.length > 0) {
                    if (this.BCCSelections.indexOf(recipient.Id) > -1) {
                        let addedRecipient = recipient.Name;
                        if (recipient.UserType == 1 || this.userService.currentUser.UserType == 1) {
                            addedRecipient += ' <' + recipient.Email + '>';
                        }
                        if (this.mailDetail.BCCDisplayMailId.length == 0) {
                            this.mailDetail.BCCDisplayMailId = addedRecipient;
                        } else {
                            this.mailDetail.BCCDisplayMailId = this.mailDetail.BCCDisplayMailId + '; ' + addedRecipient;
                        }
                        if (this.mailDetail.BCCSelectedMailId.length == 0) {
                            this.mailDetail.BCCSelectedMailId = addedRecipient + ' ';
                            this.mailDetail.BCCMailId = recipient.Email;
                        }
                        else {
                            this.mailDetail.BCCSelectedMailId = this.mailDetail.BCCSelectedMailId + addedRecipient + ' ';
                            this.mailDetail.BCCMailId = this.mailDetail.BCCMailId + ';' + recipient.Email;
                        }

                        if (this.mailDetail.peopleIds == '') {
                            this.mailDetail.peopleIds = recipient.Id + '||' + recipient.Relationship;
                        } else {
                            this.mailDetail.peopleIds = this.mailDetail.peopleIds + ',' + recipient.Id + '|| ';
                        }

                        if (recipient.Relationship == 'Mother' || recipient.Relationship == 'Step Mother') {
                            this.mailDetail.personCodeMother = 1;
                        }
                        if (recipient.Relationship == 'Father' || recipient.Relationship == 'Step Father') {
                            this.mailDetail.personCodeFather = 2;
                        }
                    }
                }
            });

            // Closing the dialog box
            this.dialogBox.close(true);
        }
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: resets the data and closes the dialog box
        // NOTE: we don't just use filter because we want to keep the reference
        if (this.mailDetail.toSelectedMailId == '') {
            this.toSelected = undefined;
        }
        for (let i = 0; i < this.toSelections.length; i++) {
            if (!this.originalToSelections.includes(this.toSelections[i])) {
                this.toSelections.splice(i, 1);
                i -= 1;
            }
        }
        for (let i = 0; i < this.CCSelections.length; i++) {
            if (!this.originalCCSelections.includes(this.CCSelections[i])) {
                this.CCSelections.splice(i, 1);
                i -= 1;
            }
        }
        for (let i = 0; i < this.BCCSelections.length; i++) {
            if (!this.originalBCCSelections.includes(this.BCCSelections[i])) {
                this.BCCSelections.splice(i, 1);
                i -= 1;
            }
        }
        this.dialogBox.close(false);
    }

    deselectAll() {
        // PRE: the deselect all button is clicked
        // POST: unselects all checkboxes
        // NOTE: WE MUST MAINTAIN THE REFERENCES, DO NOT RESET THEM TO EMPTY ARRAYS
        this.disableCCTo = false;
        this.toSelections.splice(0, this.toSelections.length);
        this.CCSelections.splice(0, this.CCSelections.length);
        this.BCCSelections.splice(0, this.BCCSelections.length);

        // Parent is always selected
        if (this.CCDisabledEmailId) {
            this.CCSelections.push(this.CCDisabledEmailId);
        }
    }

    // Methods
    changeTerm(term: number) {
        // PRE: a new term is selected
        // POST: resets the data for the selected term
        // NOTE: WE MUST MAINTAIN THE REFERENCES, DO NOT RESET THEM TO EMPTY ARRAYS
        this.disableCCTo = false;
        this.viewOption = term;
        // this.value = term;
        this.toSelections.splice(0, this.toSelections.length);
        this.CCSelections.splice(0, this.CCSelections.length);
        this.BCCSelections.splice(0, this.BCCSelections.length);
        this.getRecipients();
    }

    getRecipients(force = false) {
        // POST: obtains the student recipients

        // Ensuring that the send email service's properties are synced
        const differences = this.allAdvisors != this.sendEmailService.allAdvisors
            || this.allCounselors != this.sendEmailService.allCounselors
            || this.allPrincipals != this.sendEmailService.allPrincipals
            || this.allSiteAdministrators != this.sendEmailService.allSiteAdmin
            || this.allDistrictAdministrators != this.sendEmailService.allDistrictAdmin
            || this.allCoTeachers != this.sendEmailService.allCoTeachers
            || this.allNurses != this.sendEmailService.allNurses;
        this.sendEmailService.allAdvisors = this.allAdvisors;
        this.sendEmailService.allCounselors = this.allCounselors;
        this.sendEmailService.allPrincipals = this.allPrincipals;
        this.sendEmailService.allSiteAdmin = this.allSiteAdministrators;
        this.sendEmailService.allDistrictAdmin = this.allDistrictAdministrators;
        this.sendEmailService.allCoTeachers = this.allCoTeachers;
        this.sendEmailService.allNurses = this.allNurses;

        // Only run the call if the properties are different or we haven't gotten them yet
        if (!this.getRecipientSubscription || differences || force) {

            // Ensuring we only ever have one recipient subscription
            if (this.getRecipientSubscription) {
                this.getRecipientSubscription.unsubscribe();
            }

            // Running the subscription
            this.getRecipientSubscription = this.sendEmailService.getStudentRecipients(this.viewOption).subscribe((recipients) => {
                if (this.V10 && recipients.filter(r => r.Id == this.userService.currentUser.MemberId).length == 0) {
                    const currentRecipient = new Recipient();
                    currentRecipient.Email = this.userService.currentUser.Email;
                    currentRecipient.Id = this.userService.currentUser.MemberId;
                    currentRecipient.Name = this.userService.currentUser.LastName + ', ' + this.userService.currentUser.FirstName;
                    currentRecipient.TeacherName = currentRecipient.Name;
                    currentRecipient.UserType = currentRecipient.UserType;
                    recipients.push(currentRecipient);
                }
                this.checkDefaultMails();
            });
            this.subscriptions.push(this.getRecipientSubscription);
        }
    }

    canSendTo(recipient: Recipient) {
        // PRE: a recipient to check
        // POST: returns true if you can send mail to the recipient
        return this.userType == 1 ||
            recipient.UserType == 1 ||
            recipient.Relationship == 'Teacher' ||
            recipient.Relationship == 'Counselor' ||
            recipient.Relationship == 'Principal' ||
            recipient.Relationship == 'Assistant Principal' ||
            recipient.Relationship == 'Site Administrator' ||
            recipient.Relationship == 'Advisor';
    }

    canCCTo(recipient: Recipient) {
        // PRE: a recipient to check
        // POST: returns true if you can CC mail to the recipient
        let canCC = false;
        if (this.BCCSelections.filter(s => s == recipient.Id).length > 0) {
            canCC = true;
        }
        else if ((recipient.UserType != 2 || this.disableCCTo != true) && recipient.Id != this.CCDisabledEmailId) {
            canCC = true;
        }
        return canCC;
    }

    toggleSelection(recipient: Recipient, idArray: Array<number>, forceValidation = false, checkBCC = false) {
        // PRE: a recipient to toggle and an id array to toggle within
        // POST: removes the recipient if that recipient is in the array. Otherwise, adds the recipient to that array.
        //       Also, performs validation sometimes (???)
        const index = idArray.indexOf(recipient.Id);
        if (index > -1) {
            idArray.splice(index, 1);
        } else {
            idArray.push(recipient.Id);
        }
        if (this.userType == 1 || forceValidation) {
            this.validateSelections();
        }
        if (checkBCC && recipient.UserType == 2) {
            let BCCParentContactCount = 0;
            for (let i = 0; i < this.BCCSelections.length; i++) {
                const BCCRecipient = this.recipients.find(r => r.Id == this.BCCSelections[i]);
                if (BCCRecipient && BCCRecipient.UserType == 2) {
                    BCCParentContactCount = BCCParentContactCount + 1;
                }
            }
            if (BCCParentContactCount < 2) {
                this.disableCCTo = false;
            }
        }
        if (checkBCC) {
            // This is logically unnecessary because it literally does nothing
            // Also, DO NOT CHANGE THE REFERENCE
            // if (this.CCSelections.filter(s => s == recipient.Id)[0] != undefined) {
            //     this.CCSelections = this.CCSelections.filter(s => s != recipient.Id);
            // }
            if (this.CCDisabledEmailId == recipient.Id && this.BCCSelections.filter(s => s == recipient.Id).length == 0 && this.CCSelections.filter(s => s == recipient.Id).length == 0) {
                this.CCSelections.push(recipient.Id);
            }
        }
    }

    validateSelections() {
        // POST: performs validation on a selection to show warning modal
        //       This shows if more than 1 parent has been selected
        const selectionMoreThanOne = [];

        // Validating To selections
        if (this.toSelections != undefined && this.toSelections != null) {
            for (let i = 0; i < this.toSelections.length; i++) {
                const toSelection = this.recipients.find(recipient => recipient.Id == this.toSelections[i]);
                if (toSelection != undefined && toSelection != null && toSelection.UserType == 2) {
                    selectionMoreThanOne.push(toSelection.Id);
                }
            }
        }

        // Validating CC selections
        if (this.CCSelections != undefined && this.CCSelections != null && this.CCSelections.length > 0) {

            // Determining how many people we have CCed
            let ccCount = 0;
            for (let i = 0; i < this.CCSelections.length; i++) {
                const CCSelection = this.recipients.find(recipient => recipient.Id == this.CCSelections[i]);
                if (CCSelection.UserType == 2) {
                    ccCount += 1;
                }
            }

            // Determining if we've selected more than one CC
            if (ccCount > 1) {
                for (let i = 0; i < this.CCSelections.length; i++) {
                    const CCSelection = this.recipients.find(recipient => recipient.Id == this.CCSelections[i]);
                    const index = selectionMoreThanOne.indexOf(this.CCSelections[i]);
                    if (CCSelection != undefined && CCSelection != null && CCSelection.UserType == 2 && index == -1) {
                        selectionMoreThanOne.push(CCSelection.Id);
                    }
                }
            }
        }

        // Validing BCC selections
        if (this.BCCSelections != undefined && this.BCCSelections != null && this.BCCSelections.length > 0 && selectionMoreThanOne.length > 0) {
            for (let i = 0; i < this.BCCSelections.length; i++) {
                const BCCselection = this.recipients.find(recipient => recipient.Id == this.BCCSelections[i]);
                const index = selectionMoreThanOne.indexOf(this.BCCSelections[i]);
                if (BCCselection != undefined && BCCselection != null && BCCselection.UserType == 2 && index == -1) {
                    selectionMoreThanOne.push(BCCselection.Id);
                }
            }
        }

        // Check validity
        if (selectionMoreThanOne != undefined && selectionMoreThanOne != null && selectionMoreThanOne.length > 1) {

            // Showing warning
            const dialogBox = this.dialog.open(RecipientChangeWarningDialogComponent, {
                disableClose: true
            });

            // Upon warning close, resolve errors
            this.subscriptions.push(
                dialogBox.afterClosed().subscribe(() => {
                    this.disableCCTo = false;

                    // Ensuring there are selections to copy from
                    if (this.CCSelections != undefined && this.CCSelections != null && this.CCSelections.length > 0 || this.toSelections != undefined && this.toSelections != null && this.toSelections.length > 0) {

                        // Ensuring there are BCC selections to copy to
                        if (this.BCCSelections == undefined || this.BCCSelections == null) {
                            this.BCCSelections.splice(0, this.BCCSelections.length);    // DO NOT CHANGE THE REFERENCE
                        }

                        // If this is a teacher, copy over all to selections
                        if (this.userType == 1) {
                            for (let i = 0; i < this.toSelections.length; i++) {
                                const toSelection = this.recipients.find(recipient => recipient.Id == this.toSelections[i]);
                                if (toSelection && toSelection.UserType == 2) {
                                    if (this.BCCSelections.indexOf(this.toSelections[i]) == -1) {
                                        this.BCCSelections.push(this.toSelections[i]);
                                    }
                                    const index = this.toSelections.indexOf(this.toSelections[i]);
                                    if (index > -1) {
                                        this.toSelections.splice(index, 1);
                                        i--;
                                    }
                                    this.disableCCTo = true;
                                }
                            }
                        }

                        // for both teachers and parents, copy over all CC selections
                        for (let i = 0; i < this.CCSelections.length; i++) {
                            const CCSelection = this.recipients.find(recipient => recipient.Id == this.CCSelections[i]);
                            if (CCSelection && CCSelection.UserType == 2) {
                                if (this.BCCSelections.indexOf(this.CCSelections[i]) == -1) {
                                    this.BCCSelections.push(this.CCSelections[i]);
                                }
                                if (CCSelection.Id != this.CCDisabledEmailId) {
                                    const index = this.CCSelections.indexOf(this.CCSelections[i]);
                                    if (index > -1) {
                                        this.CCSelections.splice(index, 1);
                                        i--;
                                    }
                                    this.disableCCTo = true;
                                }
                            }
                        }
                    }
                })
            );
        }
    }

    checkDefaultMails() {
        // PRE: the recipients must be set
        // POST: checks the default emails
        // NOTE: WE MUST MAINTAIN THE REFERENCES, DO NOT RESET THEM TO EMPTY ARRAYS
        // this.toSelections.splice(0, this.toSelections.length);
        const existingMail = this.mailDetail.BCCMailId.split(';');
        const mail = existingMail.find(o => o == this.teacherEmailAddress);
        this.recipients.forEach(recipient => {
            if (recipient.Email == this.teacherEmailAddress) {
                if (mail == undefined || (mail != this.teacherEmailAddress) || this.mailDetail.toSelectedMailId) {
                    if (recipient.Id) {
                        const index = this.toSelections.indexOf(recipient.Id);
                        if (index == -1) {
                            this.toSelections.push(recipient.Id);
                        }
                    }
                }
            }
            if (recipient.Email == this.userEmailAddress) {
                if (recipient.Id) {
                    this.CCDisabledEmailId = recipient.Id;
                    const index = this.CCSelections.indexOf(recipient.Id);
                    if (index == -1) {
                        let BCCParentContactCount = 0;
                        this.BCCSelections.forEach(BCCSelect => {
                            if (this.recipients.find(recipient2 => recipient2.Id == BCCSelect).UserType == 2) {
                                BCCParentContactCount += 1;
                            }
                        });
                        this.CCSelections.forEach(CCSelect => {
                            if (this.recipients.find(recipient2 => recipient2.Id == CCSelect).UserType == 2) {
                                BCCParentContactCount += 1;
                            }
                        });
                        if (BCCParentContactCount < 1) {
                            this.CCSelections.push(recipient.Id);
                        }
                    }
                }
            }
        });
    }

    getScreenHeight() {
        return window.innerHeight - 100;
    }
}
